import React from "react";
import {useDispatch, useSelector} from "react-redux";
import useOnClickOutside from "use-onclickoutside";

import * as actionTypes from "../../store/actions/actionTypes";
import BookingFile from "../BookingFile";
import {MODAL_BOOKING_FILE_HIDE} from "../../store/actions/actionTypes";

const ModalBookingFile = () => {
    const auth = useSelector(state => state.auth);
    const dispatch = useDispatch();

    //
    const {show, file, booking} = useSelector(state => state.modal.bookingFile);
    const ref = React.useRef(null);
    useOnClickOutside(ref, () => hideModal());

    const hideModal = () => dispatch({type: actionTypes.MODAL_BOOKING_FILE_HIDE});

    const renderModal = () => {
        if (show) {
            return <div ref={ref} className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header p-3">
                        <h5 className="modal-title h1">{file.originalName || file.fileName}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={hideModal}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <BookingFile file={file}/>
                </div>
            </div>
        }
    }

    return (
        <div className={`modal modal-booking-file fade ${show ? 'show' : ''}`} id="modalBookingFile" tabIndex="-1" role="dialog" style={{display: "block", paddingRight: "11px"}}>
            {renderModal()}
        </div>
    )
}

export default ModalBookingFile;